import FormPage from "@/components/FormPage";
import { api } from "@/lib/api";

export default function SendNote() {
    return (
        <FormPage
            testIdPrefix="send-note"
            eyebrow="Encouragement"
            title="Send a Note"
            tagline="a few kind words"
            description="Drop a heartfelt note for a grandparent or caregiver in our village. Your words may be just what they need today."
            accentColor="red"
            fields={[
                { name: "from_name", label: "Your Name", required: true, placeholder: "e.g., A friend" },
                { name: "email", label: "Email (optional)", type: "email" },
                { name: "message", label: "Your Note", type: "textarea", required: true, rows: 7, placeholder: "Write something kind..." },
            ]}
            submitLabel="Send Note"
            onSubmit={(v) => api.post("/note", { ...v, email: v.email || null })}
            successTitle="Your kindness has been sent 💌"
            successMessage="We'll share your note with a family who needs it most."
        />
    );
}
